import request from './api'


    export class CategoryService
    {

        async getCategoriesList() {
            const response = await request({
                method: 'GET',
                url: `api/categories/list`
            });

            return response;
        }
    static get instance() { return categoryService }
}

const categoryService = new CategoryService();

export default categoryService;
